module.exports = __webpack_public_path__ + "img/neoline.cb47e0cc.png";